/**
 * APP版本管理出口
 */
import axios from '../http' // 导入http中创建的axios实例
import qs from 'qs' // 根据需求是否导入qs模块，把请求字段直接映射过来

// 接口请求地址
const api = '/c-api/'

const appVersion = {
    // 新增
    create(params) {
        return axios.post(api + 'appVersion/create', qs.stringify(params))
    },
    // 单个查看
    detail(params) {
        return axios.get(api + 'appVersion/detail', { params: params })
    },
    // 列表
    list(params) {
        return axios.get(api + 'appVersion/list', { params: params })
    },
    // 编辑
    edit(params) {
        return axios.post(api + 'appVersion/edit', qs.stringify(params))
    },
    // 删除
    remove(params) {
        return axios.post(api + 'appVersion/remove', qs.stringify(params))
    },
}

// 导出接口
export default appVersion
